import React, { useEffect } from "react";
import styled from "styled-components";
import { Flex } from "reflexbox/src";
import { withLocalizeStrings } from "../../../languages/Localize";
import { useRegisterStateValue } from "../../RegisterContext";
import PaymentGateway from "../../payment-gateway/PaymentGateway";
import { Spin } from "antd";

const StyledEPayment = styled(Flex)`
    flex-direction: column;
    width: 100%;
    height: 100%;
    justify-content: space-between;
    align-items: center;
`;

const EPayment = props => {
    const { monriFormValues } = useRegisterStateValue();

    useEffect(() => {
        if (monriFormValues) {
            localStorage.setItem("price", monriFormValues.amount);
        }
    }, [monriFormValues]);

    return <StyledEPayment>{monriFormValues ? <PaymentGateway {...monriFormValues} /> : <Spin size="large" />}</StyledEPayment>;
};

export default withLocalizeStrings(EPayment);
